import Tool, { type IToolActionInput, type IToolEnabledInput } from './Tool';
import {
  hasIntegrationRecordReference,
  hasRecordReference,
  isShapeIntegrationRecord,
  isShapeRecord,
} from '../objects/guards';

function linkedShape(object: fabric.Object): boolean {
  return (
    (hasRecordReference(object) && !isShapeRecord(object)) ||
    (hasIntegrationRecordReference(object) && !isShapeIntegrationRecord(object))
  );
}

class ToolUnlinkRecord extends Tool {
  static toolName = 'Unlink record(s)';

  static available({ selection }: IToolEnabledInput): boolean {
    if (!selection) {
      return false;
    }

    return selection.getObjects().some(linkedShape);
  }

  static action({ controller, selection }: IToolActionInput) {
    const linkedRecords = selection
      .getObjects()
      .filter(object => linkedShape(object));

    linkedRecords.forEach(record => {
      if (record.recordType) {
        record.set({ recordType: null, recordId: null });
      } else {
        record.set({ integrationRecord: null });
      }
    });

    controller.canvas.requestRenderAll();
  }
}

export default ToolUnlinkRecord;
